"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogHeader = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * A wrapper for `Dialog` header content
 * (content will automatically be wrapped when using the `header` prop).
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogHeader = /*#__PURE__*/_styledComponents.default.header.withConfig({
  displayName: "DialogHeader",
  componentId: "c11n-8-107-0__sc-1ace4ml-0"
})([""]);
exports.DialogHeader = DialogHeader;
DialogHeader.displayName = 'DialogHeader';

/** @component */